/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'react',
	'prop-types'
], (React, PropTypes) => {

	return class SingleLineLink extends React.Component {

		static propTypes = {
			name: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			value: PropTypes.string.isRequired,
			enabled: PropTypes.bool.isRequired,
			clickCallback: PropTypes.function
		};

		_onKeyUp(evt) {
			switch ( evt.keyCode || evt.which) {
				case 13: return this.props.clickCallback();
				case 32: return this.props.clickCallback();
				default: break;
			}
		}

		render() {
			return (
				<div className={`carbonPropertyRow singleLineLink capp_${this.props.name}`}>
					<div tabIndex="0" className="propsLabel" ariaLabel={this.props.label}>{this.props.label}</div>
					<div className="spacer"></div>
					{this.props.enabled && <a tabIndex="0" role="link" className="propsValue" ariaLabel={this.props.value} onClick={this.props.clickCallback} onKeyUp={this._onKeyUp.bind(this)}>{this.props.value}</a>}
					{!this.props.enabled && <div tabIndex="0" className="propsLabel" ariaLabel={this.props.value} >{this.props.value}</div>}

				</div>
			);
		}
	};

});